module.exports = __webpack_public_path__ + "img/clbj.2b604d8c.png";